import { Link } from "react-router-dom"
import MarketingLayout from "../../components/marketing/MarketingLayout"
import MarketingSeo from "../../components/marketing/MarketingSeo"
import {
  measurementStudioSalesMailto,
  measurementStudioScaleMailto,
} from "../../components/marketing/salesLinks"
import { Button } from "../../components/ui"

const studioFeatures = [
  "Tagging and analytics health checks",
  "Website, GA4, and paid-media diagnostics",
  "Client and account portfolio visibility",
  "Shared audit results for your team",
  "Program scope aligned to account volume",
]

const scaleFeatures = [
  "Everything in Measurement Studio",
  "Planned custom audit standards",
  "Planned configuration targets for client accounts",
  "Planned monitoring across selected accounts",
  "Planned selected GA4 configuration updates",
  "Tailored cadence, history, and rollout planning",
]

const pricingFaqs = [
  ["Why is pricing tailored?", "Pricing depends on the number of client accounts, the tagging and analytics checks your agency needs, and how often those checks should run."],
  ["What is included in a health check?", "Programs can cover tagging coverage, website implementation, GA4 configuration and data quality, access, and paid-media measurement connections."],
  ["What does Measurement Studio Scale add?", "Measurement Studio Scale is coming soon. It is planned to add custom audit standards, configuration targets for client accounts, cross-account monitoring, and selected GA4 configuration updates."],
  ["Is automotive pricing different?", "Yes. Dealership teams use ASC TuneUp, which has Core pricing and a separate Scale roadmap on its automotive pricing page."],
]

export default function MarketingPricing() {
  return (
    <MarketingLayout>
      <MarketingSeo
        title="Measurement Studio Pricing | Jarbod"
        description="Explore tailored Measurement Studio programs for agency tagging health, analytics data quality, and consistent QA across client accounts."
        path="/pricing"
      />
      <section className="marketing-page-hero marketing-page-hero--centered">
        <div className="marketing-container marketing-page-hero__inner">
          <p className="marketing-eyebrow">Measurement Studio pricing</p>
          <h1>Pricing built around your client account portfolio.</h1>
          <p>
            Tell us how many client accounts you manage, which checks your
            agency needs, and how often they should run. We will scope a program
            around those three inputs.
          </p>
        </div>
      </section>

      <section className="marketing-section marketing-section--first">
        <div className="marketing-container marketing-pricing-grid">
          <article className="marketing-plan marketing-plan--featured">
            <div className="marketing-plan__badge">Measurement foundation</div>
            <p className="marketing-plan__name">Measurement Studio</p>
            <div className="marketing-plan__custom">Tailored</div>
            <p className="marketing-plan__unit">program pricing</p>
            <p className="marketing-plan__description">
              Repeatable tagging and data-quality checks across the account portfolio.
            </p>
            <Button as="a" href={measurementStudioSalesMailto} size="lg" fullWidth>Email sales</Button>
            <p className="marketing-plan__note">Scoped to your accounts, platforms, and coverage.</p>
            <ul>{studioFeatures.map((feature) => <li key={feature}>{feature}</li>)}</ul>
          </article>

          <article className="marketing-plan marketing-plan--neutral">
            <div className="marketing-plan__badge">Coming soon</div>
            <p className="marketing-plan__name">Measurement Studio Scale</p>
            <div className="marketing-plan__custom">Scale</div>
            <p className="marketing-plan__unit">roadmap program</p>
            <p className="marketing-plan__description">
              Planned custom standards, cross-account monitoring, and selected GA4 configuration updates.
            </p>
            <Button as="a" href={measurementStudioScaleMailto} variant="outline" size="lg" fullWidth>
              Ask about Scale
            </Button>
            <p className="marketing-plan__note">Email sales to follow availability and program details.</p>
            <ul>{scaleFeatures.map((feature) => <li key={feature}>{feature}</li>)}</ul>
          </article>
        </div>
      </section>

      <section className="marketing-section marketing-section--surface">
        <div className="marketing-container marketing-trial-band">
          <div><span>01</span><strong>Count the accounts</strong><p>Tell us how many client accounts, sites, and analytics properties your agency manages.</p></div>
          <div><span>02</span><strong>Choose the checks</strong><p>Identify the tagging, data-quality, and configuration risks that matter.</p></div>
          <div><span>03</span><strong>Set the frequency</strong><p>Choose how often your team needs each client account checked.</p></div>
        </div>
      </section>

      <section className="marketing-section marketing-section--compact">
        <div className="marketing-container marketing-faq-layout">
          <div>
            <p className="marketing-eyebrow">Pricing questions</p>
            <h2>Scope the workflow before the number.</h2>
          </div>
          <div className="marketing-faq-list">
            {pricingFaqs.map(([question, answer]) => (
              <details key={question}><summary>{question}</summary><p>{answer}</p></details>
            ))}
          </div>
        </div>
      </section>

      <section className="marketing-section marketing-section--cta">
        <div className="marketing-container marketing-cta-panel">
          <div>
            <p className="marketing-eyebrow">Automotive team?</p>
            <h2>ASC TuneUp has dealership-specific pricing.</h2>
          </div>
          <Button as={Link} to="/asc-tuneup/pricing" variant="outline" size="lg">
            View ASC TuneUp pricing
          </Button>
        </div>
      </section>
    </MarketingLayout>
  )
}

